// extracted by mini-css-extract-plugin
module.exports = {"navItem":"Navigation_navItem__2Tr8e","itemTitle":"Navigation_itemTitle__1n8Nq"};